import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import Switch from '../../../../components/UI/switch/switch';
import InsuranceTermsComponent from '../../../../components/features/insurance-block/insurance-terms';
import ModalInsuranceSuccess from '../../../../components/features/modal-insurance-success/modal-insurance-success';
import ModalAlert from '../../../../components/features/modal-alert/modal-alert';

import useInsurance from '../../../../hooks/useInsurance';
import {
  findCurrentLoan,
  SIGN_INSURANCE_FAILURE,
  SIGN_INSURANCE_SUCCESS,
} from '../../../../store/actions/customer-actions';

import { findCurrentLoanRePayments } from '../../../../store/actions/loan-actions';

import styles from './float-insurance-request.module.scss';

function FloatInsuranceRequest({ loan, device }) {
  const [showInsuranceTermsModal, setShowInsuranceTermsModal] = useState(false);
  const [showInsuranceRequest, setShowInsuranceRequest] = useState(true);

  const [expanded, setExpanded] = useState(false);
  const [hiddenHeight, setHiddenHeight] = useState(0);
  const [toggleActive, setToggleActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalErrorInfos, setModalErrorInfos] = useState({
    title: 'Ops!',
    content: 'Houve um erro na contratação de seu seguro, tente novamente!',
    visible: false,
  });

  const dispatch = useDispatch();

  const { isLoanInsured, signInsurance, calculateDailyAmount, getMonthlyAmount } = useInsurance(loan);

  const hiddenRef = useRef();
  const successModalRef = useRef(null);

  const toggleSwitch = () => {
    setToggleActive((state) => !state);
    handleToggleRecurringInsuranceTerms();
  };

  const handleToggleRecurringInsuranceTerms = () => {
    setShowInsuranceTermsModal(!showInsuranceTermsModal);

    if (toggleActive) {
      setToggleActive(!toggleActive);
    }
  };

  const hideTemporarilyInsuranceRequest = () => {
    setShowInsuranceRequest(false);
  };

  const toggleError = () => {
    setModalErrorInfos({ ...modalErrorInfos, visible: !modalErrorInfos.visible });
  };

  const closeSuccessModal = () => {
    successModalRef.current?.closeModal();
    hideTemporarilyInsuranceRequest();
    dispatch(findCurrentLoan(device));
    dispatch(findCurrentLoanRePayments(device));
  };

  const isShowable = () =>
    !isLoanInsured() && loan?.conditions?.insurance?.monthlyPremiumWithTaxes > 0 && showInsuranceRequest;

  const handleSignInsurance = () => {
    setLoading(true);
    signInsurance(device).then((response) => {
      if (response.type == SIGN_INSURANCE_SUCCESS) {
        successModalRef.current?.openModal();
        handleToggleRecurringInsuranceTerms();
        setLoading(false);
      } else if (response.type == SIGN_INSURANCE_FAILURE) {
        handleToggleRecurringInsuranceTerms();
        toggleError();
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    setHiddenHeight(hiddenRef.current?.clientHeight);
  }, [hiddenRef, showInsuranceRequest]);

  // If is loan insured not return the card
  return !isShowable() ? null : (
    <>
      <div
        className={`${styles.floatWrapper} ${expanded && styles.expanded}`}
        style={{ bottom: expanded ? 0 : -hiddenHeight - 16 }} // Container + padding
      >
        <div className={`${styles.border} ${styles.borderSmall}`} />

        <div className={styles.displayedContentWrapper} onClick={() => setExpanded(!expanded)}>
          <div className={styles.displayedContent}>
            <img src="/image/bell.png" alt="Garanta sua proteção" />
            <div className={styles.displayedContentText}>
              <span className={styles.displayedContentTextGradient}>Se você ativar agora, garante super proteção!</span>
              <span>
                Menos de <strong>{calculateDailyAmount()} centavos </strong> p/dia
              </span>
              <span>({getMonthlyAmount()} por mês)</span>
            </div>
          </div>

          <Switch id="floatSwitchInsurance" toggle={toggleSwitch} active={toggleActive} />
        </div>

        <div className={styles.hiddenContentWrapper} ref={hiddenRef}>
          <div className={`${styles.border}}`} />

          <div className={styles.hiddenContent}>
            <div className={`${styles.benefitWrapper}`}>
              <img src="/image/check.png" alt="Icone de item da lista" />
              <span>Perda do emprego CLT</span>
            </div>

            <div className={`${styles.benefitWrapper}`}>
              <img src="/image/check.png" alt="Icone de item da lista" />
              <span>Morte ou invalidez</span>
            </div>

            <div className={`${styles.benefitWrapper}`}>
              <img src="/image/check.png" alt="Icone de item da lista" />
              <span>Acidentes</span>
            </div>

            <div className={styles.knowMoreCard}>
              <div>
                Proteja seu empréstimo! Pode cancelar em
                <strong>até 10 dias de graça! </strong>
                <span className={styles.knowMoreText} onClick={handleToggleRecurringInsuranceTerms}>
                  Saiba mais
                </span>
              </div>
            </div>

            <div className={styles.noThanksButton} onClick={hideTemporarilyInsuranceRequest}>
              Agora não, obrigado
            </div>
          </div>
        </div>
      </div>

      <ModalInsuranceSuccess ref={successModalRef} onClick={closeSuccessModal} />

      {showInsuranceTermsModal && (
        <InsuranceTermsComponent
          handleShowTerms={handleToggleRecurringInsuranceTerms}
          handleClickButton={handleSignInsurance}
          loading={loading}
          withButton
        />
      )}

      {modalErrorInfos.visible && (
        <ModalAlert
          showModal={toggleError}
          closeModalFunction={toggleError}
          content={modalErrorInfos.content}
          title={modalErrorInfos.title}
        />
      )}
    </>
  );
}

export default React.memo(FloatInsuranceRequest);
